// extracted by mini-css-extract-plugin
module.exports = {"inputTitle":"Register_inputTitle__GJ5o-","loginInput":"Register_loginInput__3wziu","button":"Register_button__ql8T8","captcha":"Register_captcha__32kSR"};